export enum CookieKeys {
  session = 'jaycar.session',
  csrfToken = 'jaycar.csfr',
  callback = 'jaycar.callback',
}
